import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getProblems } from "../../actions/problem";
import Problem from "./Problem";

const Problems = ({ problem: { problems, loading }, getProblems }) => {
  useEffect(() => {
    getProblems();
  }, [getProblems]);

  const [diff, setDiff] = useState("");

  const onChange = (e) => {
    setDiff(e.target.value);
  };

  return (
    <>
      {loading && (
        <img
          src={require("../../images/load2.gif")}
          alt='Loading . . . '
          className='load'
        />
      )}
      <div className='problems'>
        {!loading && (
          <select className='my-4 form-control' onChange={(e) => onChange(e)}>
            <option value='' disabled selected hidden>
              Difficulty
            </option>
            <option value='Easy'>Easy</option>
            <option value='Medium'>Medium</option>
            <option value='Hard'>Hard</option>
            <option value=''>All</option>
          </select>
        )}
        {diff !== ""
          ? problems
              .filter((problem) => problem.difficulty === diff)
              .map((problem) => <Problem key={problem._id} problem={problem} />)
          : problems.map((problem) => (
              <Problem key={problem._id} problem={problem} />
            ))}
      </div>
    </>
  );
};

Problems.propTypes = {
  getProblems: PropTypes.func.isRequired,
  problem: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  problem: state.problem,
});

export default connect(mapStateToProps, { getProblems })(Problems);
